import { Page } from "shared/react";

// const EMPTY_FEED = <Text title="Empty news feed" children="Follow some more people to fill your feed." />;
// const DONE_FEED = <Text title="All done!" children="You're done. Go outside!" />;

export function PostsPage(): React.ReactElement {
	return (
		<Page title="Posts">
			<section>
				<h1>Posts</h1>
				<p>(Posts here)</p>
			</section>
		</Page>
	);
}
